export const API_GET_SAFEPLACE_APPOINTMENT = 'API_GET_SAFEPLACE_APPOINTMENT';
export const API_GET_SAFEPLACE_APPOINTMENT_SUCCESS = 'API_GET_SAFEPLACE_APPOINTMENT_SUCCESS';
export const API_GET_SAFEPLACE_APPOINTMENT_FAIL = 'API_GET_SAFEPLACE_APPOINTMENT_FAIL';

export const API_POST_USE_SAFEPLACE_QRCODE = 'API_POST_USE_SAFEPLACE_QRCODE'

export const API_POST_CANCEL_SAFEPLACE_QRCODE ='API_POST_CANCEL_SAFEPLACE_QRCODE'

export const API_POST_TERMINATE_SAFEPLACE_QRCODE = 'API_POST_TERMINATE_SAFEPLACE_QRCODE'
export const API_GET_ALL_SAFEPLACE_QRCODE = 'API_GET_ALL_SAFEPLACE_QRCODE'
export const API_GET_ALL_SAFEPLACE_QRCODE_SUCCESS = 'API_GET_ALL_SAFEPLACE_QRCODE_SUCCESS'

export const SET_QR_SEARCH = 'SET_QR_SEARCH';